/* @ngInject */
function CampaignMaterialsFoldersController ($rootScope, $scope, ArtCollectionsService, ToastService, CampaignService, CampaignActionService) {
  $scope.isOrganized = false
  $scope.selectedFolders = []

  const api = {
  }

  this.getApi = () => api

  activate()

  function activate () {

  }

  const deregisterSelectMaterialFloatingToolBar = $rootScope.$on('campaign.select-material-floating-tool-bar', function (event, info) {
    if (!info.materials?.length) {
      $scope.selectedFolders = []
    }
  })

  $scope.$on('$destroy', () => {
    deregisterSelectMaterialFloatingToolBar()
  })

  $scope.unbindFolderCampaign = (collection) => {
    const onClose = (bindDetails) => {
      if (bindDetails) {
        ArtCollectionsService.unbindArtCollectionFromCampaign({ campaignId: $scope.campaign.id, artCollectionId: collection.id })
          .then(() => {
            $scope.reloadCollections()
            ToastService.defaultSuccessToast()
            $scope.$emit('campaign.reload-actions')
          })
      }
    }

    CampaignService.openUnbindCampaignDialog(collection, 'arts', onClose)
  }

  $scope.selectFolder = (folder) => {
    const folderIndex = $scope.selectedMaterials.findIndex(f => f.id === folder.id && !('isTemplate' in f))
    if (folderIndex !== -1) {
      $scope.selectedMaterials.splice(folderIndex, 1)
      $scope.$emit('campaign.set-schedule-date', CampaignActionService.getSelectedScheduleDate($scope.selectedMaterials, $scope.selectedScheduleDate))
    } else {
      if (CampaignActionService.validateScheduleDateOnTemplateLink(folder, $scope.selectedScheduleDate)) {
        $scope.$emit('campaign.set-schedule-date', $scope.selectedScheduleDate || folder.scheduledDate)
        $scope.selectedMaterials.push(folder)
      }
    }
  }

  $scope.isFolderDisabled = (folderScheduleDate) => {
    if (!folderScheduleDate || !$scope.selectedScheduleDate) return false
    if (folderScheduleDate === $scope.selectedScheduleDate) return false
    return true
  }
}

export { CampaignMaterialsFoldersController }
